import { useEffect, useState } from "react";

export default function Loader() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-white via-[#f0f5ed] to-white">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#4a7c59]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#2d5a3f]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#4a7c59]/5 rounded-full blur-2xl animate-float"></div>
      </div>

      {/* Main Loader Content */}
      <div className="relative z-10 text-center">
        {/* Animated Logo Circle */}
        <div className="relative mb-8">
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 border-4 border-[#4a7c59]/20 rounded-full animate-ping"></div>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-28 h-28 border-4 border-[#4a7c59]/30 rounded-full animate-pulse"></div>
          </div>
          <div className="relative w-24 h-24 bg-gradient-to-r from-[#4a7c59] to-[#2d5a3f] rounded-2xl flex items-center justify-center shadow-2xl animate-bounce">
            <span className="text-white text-4xl font-bold">O</span>
          </div>
        </div>

        {/* Brand Name with Animation */}
        <div className="mb-6">
          <h2 className="text-3xl md:text-4xl font-bold text-[#4a7c59] tracking-wide animate-fade-in">
            Olive's
          </h2>
          <p className="text-[#2d5a3f] font-semibold tracking-wider text-sm md:text-base animate-fade-in-up">
            DENTAL CLINIC
          </p>
        </div>

        {/* Animated Loading Bar */}
        <div className="w-64 md:w-80 mx-auto mb-6">
          <div className="h-1 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full w-0 bg-gradient-to-r from-[#4a7c59] to-[#2d5a3f] rounded-full animate-progress"></div>
          </div>
        </div>

        {/* Loading Text with Dots */}
        <div className="flex items-center justify-center gap-1 text-[#4a7c59] text-sm font-medium">
          <span>Loading</span>
          <span className="animate-bounce" style={{ animationDelay: "0s" }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: "0.2s" }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: "0.4s" }}>.</span>
        </div>

        {/* Dental Icon Animation */}
        <div className="flex justify-center gap-3 mt-8">
          <div className="w-2 h-2 bg-[#4a7c59] rounded-full animate-pulse"></div>
          <div className="w-2 h-2 bg-[#4a7c59] rounded-full animate-pulse" style={{ animationDelay: "0.3s" }}></div>
          <div className="w-2 h-2 bg-[#4a7c59] rounded-full animate-pulse" style={{ animationDelay: "0.6s" }}></div>
          <div className="w-2 h-2 bg-[#2d5a3f] rounded-full animate-pulse" style={{ animationDelay: "0.9s" }}></div>
          <div className="w-2 h-2 bg-[#2d5a3f] rounded-full animate-pulse" style={{ animationDelay: "1.2s" }}></div>
        </div>

        {/* Tagline */}
        <p className="text-xs text-gray-400 mt-6 animate-fade-in-up">
          Where beautiful smiles begin ✨
        </p>
      </div>
    </div>
  );
}